import { message } from "antd";

message.config({
  top: 60,
  duration: 2,
  maxCount: 3,
});
const Message = () => {
  return message;
};

export default Message;
